import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPlus, faEdit, faTrash, faEye, faSortUp, faSortDown} from '@fortawesome/free-solid-svg-icons';
import '../css/App.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AddAccountModal from '../Handle_Accounts/AddAccountModal';
import ViewAccountModal from '../Handle_Accounts/ViewAccountModal';
import ConfirmDelete from '../Main/ConfirmDelete';
import useIsPhone from '../Main/useIsPhone';
import { PROXY } from '../components/constants';
import TopBar from '../Bars/TopBar';
import SideBar from '../Bars/SideBar';


function Accounts() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ActiveRow, setActiveRow] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [deleteAccountId, setDeleteAccountId] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [isDeleteSuccess, setIsDeleteSuccess] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const isPhone = useIsPhone();


  useEffect(() => {
    axios.defaults.withCredentials = true;
    axios.get(`${PROXY}/faccounts`)
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    axios.get(`${PROXY}/session`)
      .then(res => {
        if (res.data.valid) {
          console.log("User data from response:", res.data.userData);
          setUserData(res.data.userData);
          if (res.data.userData.account_type !== 1) {
            navigate('/');
          }
        } else {
          console.log("Redirecting to login page");
          navigate('/');
        }
      })
      .catch(err => console.log(err));
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openViewModal = (account) => {
    setActiveRow(data.findIndex(a => a.id === account.id));
    setSelectedAccount(account);
  };

  const closeViewModal = () => {
    setActiveRow(null);
    setSelectedAccount(null);
  };
  const handleDelete = (id) => setDeleteAccountId(id);
  const handleConfirmDelete = () => {
    axios.delete(`${PROXY}/daccount/${deleteAccountId}`)
      .then(res => {
        setData(data.filter(account => account.id !== deleteAccountId));
        setDeleteAccountId(null);
        setIsDeleteSuccess(true);
        setTimeout(() => {
          setIsDeleteSuccess(false);
          window.location.reload();
        }, 2000);
      })
      .catch(err => console.log(err));
  };

  const handleCancelDelete = () => setDeleteAccountId(null);

  const handleSort = (columnKey) => {
    let direction = 'asc';
    if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: columnKey, direction });

    const sortedData = [...data].sort((a, b) => {
      let aValue, bValue;
      if (columnKey === 'name') {
        aValue = `${a.first_name || ''} ${a.middle_name || ''} ${a.last_name || ''}`.toLowerCase();
        bValue = `${b.first_name || ''} ${b.middle_name || ''} ${b.last_name || ''}`.toLowerCase();
      } else {
        aValue = a[columnKey];
        bValue = b[columnKey];
      }

      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    setData(sortedData);
  };


  const handleSearchInput = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredData = data.filter(account => {
    const matchesSearch = (
      account.first_name.toLowerCase().includes(searchQuery) ||
      account.middle_name?.toLowerCase().includes(searchQuery) ||
      account.last_name.toLowerCase().includes(searchQuery) ||
      account.email.toLowerCase().includes(searchQuery) ||
      account.username.toLowerCase().includes(searchQuery) ||
      account.account_type.toString().toLowerCase().includes(searchQuery)
    );

    const isNotCurrentUser = userData ? account.username !== userData.username : true;

    return matchesSearch && isNotCurrentUser;
  });

  return (
    <div className="flex flex-col md:flex-row h-screen pagescreen" style={{overflowY: isPhone ? 'scroll' : ''}}>
      <SideBar/>
      <div className="flex-1 overflow-auto">
        <TopBar/>
        <div className="p-8">
        <div className="mt-4 flex justify-end items-center mr-[-1px]">
  <div className="flex items-center space-x-4" style={{ width: isPhone ? '100%' : 'auto' }}>
    <input
      type="text"
      value={searchQuery}
      onChange={handleSearchInput}
      placeholder="Search..."
      className="px-10 py-2 border rounded text-black"
      style={{ width: isPhone ? '70%' : 'auto' }}
    />
    <button
      onClick={openModal}
      className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-[10.1px] px-4 rounded"
      style={{
        width: isPhone ? '30%' : 'auto',
        fontSize: isPhone ? '15px' : 'inherit',
        height: isPhone ? '100%' : 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        <span>{isPhone ? 'Add' : 'Add Account'}</span>
      </div>
    </button>
  </div>
  <AddAccountModal isOpen={isModalOpen} onClose={closeModal} />
</div>


          <div className="table-container mt-3" style={{marginBottom: isPhone ? '20%' : '',  height: '650px', overflowY: 'auto' }}>
            <table className="w-full">
              <thead>
                <tr>
                  <th onClick={() => handleSort('#')} className="sticky top-0 bg-gray-800 text-white px-4 py-2 cursor-pointer z-10">
                    #
                    {sortConfig.key === '#' ? (
                      sortConfig.direction === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
                    ) : null}
                  </th>
                  <th onClick={() => handleSort('name')} className="sticky top-0 bg-gray-800 text-white px-4 py-2 cursor-pointer z-10">
                    Full Name
                    {sortConfig.key === 'name' ? (
                      sortConfig.direction === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
                    ) : null}
                  </th>
                  {!isPhone && (
                    <th onClick={() => handleSort('username')} className="sticky top-0 bg-gray-800 text-white px-4 py-2 cursor-pointer z-10">
                      Username
                      {sortConfig.key === 'username' ? (
                        sortConfig.direction === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
                      ) : null}
                    </th>
                  )}
                  <th onClick={() => handleSort('account_type')} className="sticky top-0 bg-gray-800 text-white px-4 py-2 cursor-pointer z-10">
                    Account Type
                    {sortConfig.key === 'account_type' ? (
                      sortConfig.direction === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
                    ) : null}
                  </th>
                  <th className="sticky top-0 bg-gray-800 text-white px-4 py-2 z-10">Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.map((account, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2 text-center">{index + 1}</td>
                    <td className="border px-4 py-2 text-center">{`${account.first_name || ''} ${account.middle_name ? account.middle_name + ' ' : ''}${account.last_name || ''}`}</td>
                    {!isPhone && <td className="border px-4 py-2 text-center">{account.username}</td>}
                    <td className="border px-4 py-2 text-center">
                      {account.account_type === 1 && 'Admin'}
                      {account.account_type === 2 && 'Staff'}
                      {account.account_type === 3 && 'Client'}
                      {account.account_type === 4 && 'Retainer'}
                    </td>
                    <td className="border px-4 py-2 text-center" style={{ fontSize: isPhone ? '10px' : '', paddingRight: isPhone ? '4%' : '', paddingLeft: isPhone ? '4%' : ''}}>
                      <div style={{ display: isPhone ? 'flex' : 'block', flexDirection: isPhone ? 'row' : 'column', alignItems: isPhone ? 'center' : 'flex-start', justifyContent: isPhone ? 'center' : 'flex-start' }}>
                        <button onClick={() => openViewModal(account)} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 mr-2 rounded hover:text-white" style={{ paddingLeft: isPhone ? '5px' : '', paddingRight: isPhone ? '5px' : '' }}>
                          <FontAwesomeIcon icon={faEye} /><span style={{ marginLeft: isPhone ? '0' : '0.5em' }}>{isPhone ? '' : 'View'}</span>
                        </button>
                        {selectedAccount && (
                          <ViewAccountModal account={selectedAccount} isOpen={!!selectedAccount} onClose={closeViewModal} />
                          )}
                        <Link to={`/editaccount/${account.id}`}>
                          <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-3 mr-2 rounded hover:text-white" style={{ paddingLeft: isPhone ? '5px' : '', paddingRight: isPhone ? '5px' : '' }}>
                            <FontAwesomeIcon icon={faEdit} /><span style={{ marginLeft: isPhone ? '0' : '0.5em' }}>{isPhone ? '' : 'Edit'}</span>
                          </button>
                        </Link>
                        <button onClick={() => handleDelete(account.id)} className="bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-2 rounded hover:text-white" style={{ paddingLeft: isPhone ? '5px' : '', paddingRight: isPhone ? '5px' : '' }}>
                          <FontAwesomeIcon icon={faTrash} /><span style={{ marginLeft: isPhone ? '0' : '0.5em' }}>{isPhone ? '' : 'Delete'}</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      </div>
      {deleteAccountId && (
        <ConfirmDelete
          message="Are you sure you want to delete this account?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
      {isDeleteSuccess && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 rounded shadow-md" style={{ backgroundColor: '#f59e0b' }}>
          <p className="text-white text-center">Data successfully deleted</p>
        </div>
      )}
    </div>
  );
}

export default Accounts;
